/**
 * @generated SignedSource<<7b34c7d44a2f13ed8b0fb328cf70b954>>
 * @relayHash fe30c06686fb9e940327b63b59aa3c35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ab285270aa566f21999e55375f3290bbfc5881b0bc0d616f89b77067b8b185ef

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraFieldOptionIdsFilterOperation = "ALLOW" | "EXCLUDE" | "%future added value";
export type JiraFieldOptionIdsFilterInput = {
  operation: JiraFieldOptionIdsFilterOperation;
  optionIds: ReadonlyArray<string>;
};
export type resolutionQuery$variables = {
  ari: string;
  filterById?: JiraFieldOptionIdsFilterInput | null | undefined;
  transitionId: string;
};
export type resolutionQuery$data = {
  readonly node: {
    readonly resolutionsForTransition?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly label: string | null | undefined;
          readonly value: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type resolutionQuery = {
  response: resolutionQuery$data;
  variables: resolutionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterById"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "transitionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "ari"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "filterById",
    "variableName": "filterById"
  },
  {
    "kind": "Variable",
    "name": "transitionId",
    "variableName": "transitionId"
  }
],
v3 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "resolutionQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraResolutionConnection",
                "kind": "LinkedField",
                "name": "resolutionsForTransition",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraResolutionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraResolution",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraResolutionField"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "resolutionQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraResolutionConnection",
                "kind": "LinkedField",
                "name": "resolutionsForTransition",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraResolutionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraResolution",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraResolutionField"
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "ab285270aa566f21999e55375f3290bbfc5881b0bc0d616f89b77067b8b185ef",
    "metadata": {},
    "name": "resolutionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5a01786e73ad98bdd793322b4a5c7393";

export default node;
